class _historyApi {
  constructor() {
    this.currentURL = [];
    this.currentURL.push(location.href);
  }

  init() {
    // ブラウザの戻る・進むボタンイベント
    window.addEventListener('popstate', this.onPopState.bind(this));
  }

  onPopState(e) {
    if (e.state) {
      e.preventDefault();
      console.log(this.currentURL);
      const prevURL = this.currentURL.splice(-1, 1);
      const url = e.state.url;
      gEvent.emit('popState', {url: url, from: prevURL[0]});
    } 
  }

  changeState(url) {
    this.currentURL.push(url);
    history.pushState({'url': url}, null, url);
    gEvent.emit('pushState', {url: url});
  }
}

const historyApi = new _historyApi();

export default historyApi;